import React, { useEffect, useState } from "react"; 
import 'react-phone-number-input/style.css'
import PhoneInput from 'react-phone-number-input'
import { Modal, Button, Form } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleCheck, faClock, faBell, faEnvelope, faSquarePhone } from '@fortawesome/free-solid-svg-icons'
import { faInstagramSquare, faFacebookSquare, faLinkedinIn, faYoutubeSquare } from '@fortawesome/free-brands-svg-icons'
import axios from "axios";
import { Link } from 'react-router-dom'
import '../Footer.css'
import { useNavigate } from "react-router-dom";
import android from '../images/android.png'
import downloadapp from '../images/Time_Express.apk'
import bag from '../images/bag.png'
import BACKEND_URL from "../api";
import { useCountry } from '../context/CountryContext';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
const fadownload = <FontAwesomeIcon icon={faDownload} />;

const facircle = <FontAwesomeIcon icon={faCircleCheck} />
const faEnvelope1 = <FontAwesomeIcon icon={faEnvelope} />
const faPhone1 = <FontAwesomeIcon icon={faSquarePhone} />
const faclock = <FontAwesomeIcon icon={faClock} />
const fabell = <FontAwesomeIcon icon={faBell} />
const fainsta = <FontAwesomeIcon icon={faInstagramSquare} />
const fafacebook = <FontAwesomeIcon icon={faFacebookSquare} />
const falinkedin = <FontAwesomeIcon icon={faLinkedinIn} />
const fayoutube = <FontAwesomeIcon icon={faYoutubeSquare} />
const LoginForm = ({ onSubmit }) => {

    return (
        <div className="shipment_cont" style={{}}>
            <img style={{ position: "absolute", right: "0", width: "10%" }} className=" lazyloaded" src={bag} alt="parcel" />
            <h4 >register now to receive your</h4>
            <h2 style={{ color: "#3c50e0", textAlign: "center" }}>10% Off</h2>
            <h4>ON YOUR FIRST SHIPMENT OVER AED 50</h4>
            <ul className="get_itms">
                <h3 className="hr-lines">
                    <span> And get exclusive advantages </span>
                </h3>

                <li style={{ paddingLeft: "2%" }}>{facircle}
                    <p style={{ fontSize: "14px" }}>Book online &amp; save<br /> Send parcels to any<br /> destination</p>
                </li>
                <li>{faclock}
                    <p style={{ fontSize: "14px" }}>Get exclusive access<br /> to early bird promotions<br /> and discount</p>
                </li>
                <li>{fabell}
                    <p style={{ fontSize: "14px" }}>Tailored notifications<br /> on your shipment<br /> status</p>
                </li>
            </ul>
            <div id="msg-form-wysija-html5cef852d21cda-2" className="wysija-msg ajax" />
        </div>
    );
};

export default function Footer() {
    const { 
        phone, 
        whatsapp,
        dhlExportRateUrl,
        dhlImportRateUrl,
        fedexExportRateUrl,
        fedexImportRateUrl,
        upsExportRateUrl,
        upsImportRateUrl,
        otherExportRateUrl,
        otherImportRateUrl
    } = useCountry();
    
    // Check if any rate tables are available
    const hasRateTables = dhlExportRateUrl || dhlImportRateUrl || fedexExportRateUrl || 
                         fedexImportRateUrl || upsExportRateUrl || upsImportRateUrl || 
                         otherExportRateUrl || otherImportRateUrl;
    const navigate = useNavigate()
    const [loggeduser, setloggeduser] = useState({
        email: "",
        phone: "",
    })
    const [msg, setmsg] = useState()
    const [errorMessage, setErrorMessage] = useState("");

    function subscribe() {
        const API_PATH = `${BACKEND_URL}/subscribe`;
        if (loggeduser.email != "" && loggeduser.phone != "") {
            if (validateEmail(loggeduser.email)) {
                axios({
                    method: 'post',
                    url: `${API_PATH}`,
                    data: loggeduser
                })
                    .then((res) => {
                        setErrorMessage("")
                        setmsg(res.data.message)
                        setTimeout(() => navigate('/register'), 1000);
                    }
                    )
                    .catch((err) => console.log(err))
            } else {
                setmsg("")
                setErrorMessage("Invalid email")
            }
        } else {
            setmsg("")
            setErrorMessage("Enter email and phone")
        }
    }

    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);

    const onLoginFormSubmit = (e) => {
        e.preventDefault();
        handleClose();
    };

    useEffect(() => {
        let time = sessionStorage.getItem('time')

        if (time == null) {
            sessionStorage.setItem('time', new Date());
            setTimeout(() => setShow(true), 11000);
        } else {
            setShow(false)
        }
    }, []);

    const validateEmail = (email) => {
        // Simple regex for email validation
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return regex.test(email);
    };

    return (
        <div>
            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton style={{ background: "#3c50e0", color: "#fff" }}>
                    <Modal.Title style={{ textAlign: "center", width: "100%" }}>Shypv
                        <p style={{ fontSize: "20px" }}>
                            Send international parcels for less
                        </p>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <>
                        <LoginForm onSubmit={onLoginFormSubmit} />

                        <form className="subscribeform" style={{ marginBottom: "10px" }}>
                            <label>Email*</label>
                            <input type="text" placeholder='Email' className="form-control mb-3" required onChange={(e) => setloggeduser({ ...loggeduser, email: e.target.value })} />
                            <label>Phone*</label>
                            {/* <input type="text" placeholder='Phone Number' className="form-control  mb-3" required onChange={(e) => setloggeduser({ ...loggeduser, phone: e.target.value })} /> */}
                            <PhoneInput
                                international
                                countryCallingCodeEditable={false}
                                defaultCountry="AE"
                                value={loggeduser.phone}
                                onChange={(newPhone) => setloggeduser({ ...loggeduser, phone: newPhone })}
                                style={{ "display": "flex", "backgroundColor": "#f7f7f7", "height": "2.9em" }}
                                className="mb-3 form-control" 
                            />
                            <div className="footer-button">
                                <button type="button" className="btn btn-sm" onClick={subscribe}>Claim 10% Off Now!</button>
                                <button type="button" className="btn btn-sm" onClick={handleClose}>No, Thanks</button>
                            </div>
                        </form>
                        <p style={{ textAlign: "center", color: "green", marginBottom: "10px" }}>
                            {msg}
                        </p>
                        <p style={{ textAlign: "center", color: "red", marginBottom: "10px" }}>
                            {errorMessage}
                        </p>
                    </>
                </Modal.Body>
            </Modal>

            <footer className="footer">
                <div className="container ">
                    <div className="row footersec" style={{ padding: "3%" }}></div>
                    <div className="row">
                        <div className="col-md-3 col-lg-3 col-xl-3">
                            <div className="block mb-4 mb-lg-0">
                                <h5 className="footer-nav-title text-light">About Shypv Parcels</h5>
                                <div className="office1">
                                    <div className="block mb-4 mb-lg-0">

                                        <p><Link to="/about-us" style={{ color: '#fff !important' }}><span dir="ltr">About Us</span></Link></p>
                                        <p><Link to="/help" style={{ color: '#fff !important' }}><span dir="ltr">Help</span></Link></p>
                                        <p><Link to="testimonials" style={{ color: '#fff !important' }}><span dir="ltr">Testimononials</span></Link></p>
                                        <p><Link to="contact-time-express" style={{ color: '#fff !important' }}><span dir="ltr">Contact Shypv</span></Link></p>
                                        <p><Link to="/improving-lives" style={{ color: '#fff !important' }}><span dir="ltr">Improving Lives</span></Link></p>
                                        <p><Link to="/medical-services" style={{ color: '#fff !important' }}><span dir="ltr">Medical Services</span></Link></p>
                                        <p><Link to="/fine-arts-enquiries" style={{ color: '#fff !important' }}><span dir="ltr">Arts & Paintings</span></Link></p>
                                        <p><Link to="/sonoco-thermosafe" style={{ color: '#fff !important' }}><span dir="ltr">Sonoco Thermosafe</span></Link></p>
                                        <p><Link to="/careers" style={{ color: '#fff !important' }}><span dir="ltr">Careers</span></Link></p>
                                        <p><Link to="/blogs" style={{ color: '#fff !important' }}><span dir="ltr">Blogs</span></Link></p>

                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-3 col-lg-3 col-xl-3">
                            <div className="block mb-4 mb-lg-0">
                                <h5 className="footer-nav-title text-light">Shypv Services</h5>
                                <div className="office1">
                                    <div className="block mb-4 mb-lg-0">

                                        <p><Link to="/client-zone" style={{ color: '#fff !important' }}><span dir="ltr">Client Zone</span></Link></p>
                                        <p><Link to="/become-a-partner" style={{ color: '#fff !important' }}><span dir="ltr">Partner Zone</span></Link></p>
                                        <p><Link to="/send/local-courier-same-day-courier" style={{ color: '#fff !important' }}><span dir="ltr">Time Services</span></Link></p>
                                        <p><Link to="/track/same-day-delivery/" style={{ color: '#fff !important' }}><span dir="ltr">Same Day Service</span></Link></p>
                                        <p><Link to="/track/next-day-delivery" style={{ color: '#fff !important' }}><span dir="ltr">Next Day  Service</span></Link></p>
                                        <p><Link to="/track/bullet-delivery" style={{ color: '#fff !important' }}><span dir="ltr">Bullet Service</span></Link></p>
                                        <p><Link to="/track/sunday-delivery" style={{ color: '#fff !important' }}><span dir="ltr">Sunday Service</span></Link></p>
                                        <p><Link to="/prohibited-restricted-items" style={{ color: '#fff !important' }}><span dir="ltr">Prohibited & Restricted Items</span></Link></p>
                                        <p><Link to="/packaging-advice" style={{ color: '#fff !important' }}><span dir="ltr">Packaging Advice</span></Link></p>
                                        <p><Link to="customs-clearance-services" style={{ color: '#fff !important' }}><span dir="ltr">Customs Clearance Services</span></Link></p>
                                        {hasRateTables && (
                                            <>
                                                <p style={{ marginTop: '10px', fontWeight: 'bold' }}>Rate Tables:</p>
                                                {dhlExportRateUrl && <p><a href={dhlExportRateUrl} target="_blank" rel="noopener noreferrer" style={{ color: '#fff !important' }}><span dir="ltr">{fadownload} DHL Export Rates</span></a></p>}
                                                {dhlImportRateUrl && <p><a href={dhlImportRateUrl} target="_blank" rel="noopener noreferrer" style={{ color: '#fff !important' }}><span dir="ltr">{fadownload} DHL Import Rates</span></a></p>}
                                                {fedexExportRateUrl && <p><a href={fedexExportRateUrl} target="_blank" rel="noopener noreferrer" style={{ color: '#fff !important' }}><span dir="ltr">{fadownload} FedEx Export Rates</span></a></p>}
                                                {fedexImportRateUrl && <p><a href={fedexImportRateUrl} target="_blank" rel="noopener noreferrer" style={{ color: '#fff !important' }}><span dir="ltr">{fadownload} FedEx Import Rates</span></a></p>}
                                                {upsExportRateUrl && <p><a href={upsExportRateUrl} target="_blank" rel="noopener noreferrer" style={{ color: '#fff !important' }}><span dir="ltr">{fadownload} UPS Export Rates</span></a></p>}
                                                {upsImportRateUrl && <p><a href={upsImportRateUrl} target="_blank" rel="noopener noreferrer" style={{ color: '#fff !important' }}><span dir="ltr">{fadownload} UPS Import Rates</span></a></p>}
                                                {otherExportRateUrl && <p><a href={otherExportRateUrl} target="_blank" rel="noopener noreferrer" style={{ color: '#fff !important' }}><span dir="ltr">{fadownload} Other Export Rates</span></a></p>}
                                                {otherImportRateUrl && <p><a href={otherImportRateUrl} target="_blank" rel="noopener noreferrer" style={{ color: '#fff !important' }}><span dir="ltr">{fadownload} Other Import Rates</span></a></p>}
                                            </>
                                        )}
                                        {/* <p><Link to="" style={{ color: '#fff !important' }}><span dir="ltr">Blog</span></Link></p> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3 col-lg-3 col-xl-3">
                            <div className="block mb-4 mb-lg-0">
                                <h5 className="footer-nav-title text-light">Join Our Community</h5>
                                <div className="office1">
                                    <div className="block mb-4 mb-lg-0">

                                        <p><Link to="/become-a-driver" style={{ color: '#fff !important' }}><span dir="ltr">Become a Driver</span></Link></p>
                                        <p><Link to="/become-a-partner" style={{ color: '#fff !important' }}><span dir="ltr">Become a Partner</span></Link></p>
                                        <h5 className="footer-nav-title text-light">Delivery To..</h5>
                                        <p><Link to="/send-parcel-to-usa" style={{ color: '#fff !important' }}><span dir="ltr">Send A Parcel To USA</span></Link></p>
                                        <p><Link to="/send-parcel-to-uk" style={{ color: '#fff !important' }}><span dir="ltr">   Send A Parcel To UK</span></Link></p>
                                        <p><Link to="/send/IN" style={{ color: '#fff !important' }}><span dir="ltr">Send A Parcel To India</span></Link></p>
                                        <p><Link to="/send/PH" style={{ color: '#fff !important' }}><span dir="ltr"> Send A Parcel To Philippines</span></Link></p>
                                        <p><Link to="/send/FR" style={{ color: '#fff !important' }}><span dir="ltr"> Send A Parcel To France</span></Link></p>
                                        <p><Link to="/send/DE" style={{ color: '#fff !important' }}><span dir="ltr">Send A Parcel To Germany</span></Link></p>
                                        <p><Link to="/send/CN" style={{ color: '#fff !important' }}><span dir="ltr">Send A Parcel To China</span></Link></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3 col-lg-3 col-xl-3">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="block mb-4 mb-lg-0">
                                        <div className="col-md-12">
                                            <h5 className="footer-nav-title text-light">General</h5>
                                            <div className="office1">
                                                <div className="block mb-4 mb-lg-0">

                                                    <p><Link to="/terms-conditions" style={{ color: '#fff !important' }}><span dir="ltr">
                                                        Terms & Conditions</span></Link></p>
                                                    <p><Link to="/privacy-cookies" style={{ color: '#fff !important' }}><span dir="ltr">Privacy & Cookies</span></Link></p>
                                                </div>
                                            </div>
                                            <div className="office1" style={{ marginTop: "7%" }}>
                                                <div className="block mb-4 mb-lg-0">
                                                    {phone && (
                                                        <p><a href={`tel:${phone.replace(/\s/g, '')}`} style={{ color: '#fff !important' }}><span dir="ltr">{faPhone1} &nbsp; &nbsp;{phone}</span></a></p>
                                                    )}
                                                    <p><a href="mailto:info@shypv.com?subject=Shypv Enquiry" style={{ color: '#fff !important' }}><span dir="ltr">{faEnvelope1} &nbsp; &nbsp;info@shypv.com</span></a></p>
                                                    {whatsapp && (
                                                        <p><a href={`https://wa.me/${whatsapp.replace(/[^\d]/g, '')}`} target="_blank" rel="noopener noreferrer" style={{ color: '#fff !important' }}><span dir="ltr">WhatsApp: {whatsapp}</span></a></p>
                                                    )}
                                                </div>
                                            </div>

                                            <div className="col-md-12">
                                                <a href={downloadapp} download="Shypv" target="_blank"><img src={android} alt="android" style={{ width: "150px" }} /></a>
                                            </div>
                                            {/* <ul className="social_icon">
                                                <li>
                                                    <a href="https://www.facebook.com/TimeExpressParcels/" target="_blank">
                                                        {fafacebook}
                                                    </a>
                                                </li>
                                                <li>
                                                    <a href="https://www.instagram.com/timeexpressparcel" target="_blank">
                                                        {fainsta}
                                                    </a>
                                                </li>
                                                <li>
                                                    <a href="https://www.linkedin.com/company/time-express-parcels/" target="_blank">
                                                        {falinkedin}
                                                    </a>
                                                </li>
                                                <li>
                                                    <a href="https://www.youtube.com/channel/UCl3obiSmUZ4t2BMpfR2KKxQ" target="_blank">
                                                        {fayoutube}
                                                    </a>
                                                </li>
                                            </ul> */}
                                        </div>

                                    </div>

                                </div>

                            </div>

                        </div>

                    </div>
                </div>
            </footer>
            <div className="copyright">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-md-12">
                            <div className="block copyright-content mb-2 mb-md-0">
                                <p className="m-0 text-light foottext">© 2022 SHYPV PARCELS | ALL RIGHTS RESERVED. </p>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>

    )
}
